// 任务状态 → badge 色调（后台规范「状态色语义」）；文字沿用 @csp/shared 的 STATUS_META（小程序也在用，不改它）
import { STATUS_META, type Priority, type TaskStatus } from "@csp/shared";

export type Tone = "default" | "green" | "amber" | "orange" | "red" | "gray" | "solid-red";

export const STATUS_TONE: Record<TaskStatus, Tone> = {
  running: "amber",
  waiting_scan: "solid-red",
  blocked: "solid-red",
  review_required: "orange",
  failed: "red",
  done: "green",
  draft: "gray",
  cancelled: "gray",
  archived: "gray",
  ready: "default",
  queued: "default",
};

export function statusLabel(s: TaskStatus): string {
  return STATUS_META[s].label;
}

export const PRIORITY_TONE: Record<Priority, Tone> = { urgent: "red", high: "orange", normal: "default", low: "gray" };

/** 变更标记种类 → badge 色调（图表里的竖线仍用 TimelineChart 的颜色） */
export const MARKER_TONE: Record<string, Tone> = {
  skill: "default",
  rollback: "red",
  "agents-md": "default",
  model: "amber",
  openclaw: "gray",
  portal: "orange",
  maturity: "green",
};

/** badge 的 class：default 不加色调类 */
export function toneClass(t: Tone): string {
  return t === "default" ? "badge" : `badge ${t}`;
}
